/** 框选显示几何与光标 */

export function normalizeDisplayBbox(a, b) {
  return {
    west: Math.min(a.lng, b.lng),
    south: Math.min(a.lat, b.lat),
    east: Math.max(a.lng, b.lng),
    north: Math.max(a.lat, b.lat)
  };
}

export function displayBboxPolygon(b) {
  const { west, south, east, north } = b;
  return {
    type: 'Feature',
    properties: {},
    geometry: {
      type: 'Polygon',
      coordinates: [[[west, south], [east, south], [east, north], [west, north], [west, south]]]
    }
  };
}

export function displayBboxHandles(b) {
  const { west, south, east, north } = b;
  const mx = (west + east) / 2;
  const my = (south + north) / 2;
  const pts = [
    ['nw', west, north],
    ['n', mx, north],
    ['ne', east, north],
    ['e', east, my],
    ['se', east, south],
    ['s', mx, south],
    ['sw', west, south],
    ['w', west, my]
  ];
  return {
    type: 'FeatureCollection',
    features: pts.map(([id, lng, lat]) => ({
      type: 'Feature',
      properties: { id },
      geometry: { type: 'Point', coordinates: [lng, lat] }
    }))
  };
}

export function applyHandleResize(origin, kind, lng, lat) {
  const next = { ...origin };
  switch (kind) {
    case 'n':
      next.north = Math.max(lat, next.south + 1e-7);
      break;
    case 's':
      next.south = Math.min(lat, next.north - 1e-7);
      break;
    case 'e':
      next.east = Math.max(lng, next.west + 1e-7);
      break;
    case 'w':
      next.west = Math.min(lng, next.east - 1e-7);
      break;
    case 'nw':
      next.west = Math.min(lng, next.east - 1e-7);
      next.north = Math.max(lat, next.south + 1e-7);
      break;
    case 'ne':
      next.east = Math.max(lng, next.west + 1e-7);
      next.north = Math.max(lat, next.south + 1e-7);
      break;
    case 'sw':
      next.west = Math.min(lng, next.east - 1e-7);
      next.south = Math.min(lat, next.north - 1e-7);
      break;
    case 'se':
      next.east = Math.max(lng, next.west + 1e-7);
      next.south = Math.min(lat, next.north - 1e-7);
      break;
    default:
      break;
  }
  return next;
}

export function cursorForHandle(kind) {
  if (!kind) return 'default';
  if (kind === 'move') return 'move';
  if (kind === 'n' || kind === 's') return 'ns-resize';
  if (kind === 'e' || kind === 'w') return 'ew-resize';
  if (kind === 'ne' || kind === 'sw') return 'nesw-resize';
  if (kind === 'nw' || kind === 'se') return 'nwse-resize';
  return 'pointer';
}

/** 框选激活时强制十字光标（Mapbox 缩放后常会改回 grab） */
export function applyOrthoBboxCursor(map, phase) {
  if (!map) return;
  try {
    const root = map.getContainer?.();
    const canvas = map.getCanvas?.();
    const wrap = map.getCanvasContainer?.();
    if (root) {
      root.classList.add('zhxt-ortho-bbox-active');
      root.classList.toggle('zhxt-ortho-bbox-drawing', phase === 'drawing');
      root.classList.toggle('zhxt-ortho-bbox-editing', phase === 'editing');
    }
    const cur = phase === 'drawing' ? 'crosshair' : (phase === 'editing' ? 'crosshair' : '');
    if (canvas && cur) {
      canvas.style.setProperty('cursor', cur, 'important');
    }
    if (wrap && cur) {
      wrap.style.setProperty('cursor', cur, 'important');
    }
  } catch (_) { /* ignore */ }
}

export function clearOrthoBboxCursor(map) {
  if (!map) return;
  try {
    const root = map.getContainer?.();
    const canvas = map.getCanvas?.();
    const wrap = map.getCanvasContainer?.();
    root?.classList.remove('zhxt-ortho-bbox-active', 'zhxt-ortho-bbox-drawing', 'zhxt-ortho-bbox-editing');
    canvas?.style?.removeProperty?.('cursor');
    wrap?.style?.removeProperty?.('cursor');
  } catch (_) { /* ignore */ }
}
